import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'swoosh',
  templateUrl: './swoosh.component.html',
  styleUrls: ['./swoosh.component.scss'],
  standalone: true,
  imports: [RouterLink, CommonModule],
})
export class SwooshComponent implements OnInit {
  /*
   * These two parameters can be left blank in the parent component
   * Populating the url with a local route will cause the text to become a hyperlink with a left chevron.  Otherwise, it will be static text
   */
  @Input() text: string;
  @Input() route: string;
  @Input() external: string;
  @Input() fragment: string;

  constructor(private Http: HttpClient) {}

  ngOnInit() {
    sessionStorage.setItem('external', this.external);
  }

  navigate() {
    this.Http.get('/api/session/partialsignout').subscribe(() => {
      window.location.href = sessionStorage.getItem('external');
    });
  }
}
